import { render, staticRenderFns } from "./CustomSettings.vue?vue&type=template&id=62b0803f"
import script from "./CustomSettings.vue?vue&type=script&lang=ts"
export * from "./CustomSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b0803f')) {
      api.createRecord('62b0803f', component.options)
    } else {
      api.reload('62b0803f', component.options)
    }
    module.hot.accept("./CustomSettings.vue?vue&type=template&id=62b0803f", function () {
      api.rerender('62b0803f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/CustomSettings.vue"
export default component.exports